import { Injectable } from "@angular/core";
import { Logradouro } from "@tivic-team/manager-ts/dist/grl";
import { PagedResponse } from "app/interfaces/paged-response.inteface";
import { LogradouroDTO } from "app/model/dtos/grl/logradouro.dto";
import { HttpGet, HttpPost, HttpPut, HttpResponse, JSONData, Quark, Url } from "sol-request-angular/dist/comunicacao";
import { IFilter } from "sol-request-angular/dist/comunicacao/interfaces/IFilter";
import { environment } from "src/environments/environment";
import { environmentv3 } from "src/environments/environment-v3";


@Injectable()
export class LogradouroController {
    constructor() { }

    async find(filtros?: IFilter): Promise<Array<Logradouro>>{
        let quark = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'grl/logradouros',
                    environment: environment,
                    filter: filtros
                }),
            }),
            new HttpResponse(
                new Array<Logradouro>()
            )
        );
        return await quark.call();
    }

    findLogradouros(filtros?: IFilter): Promise<PagedResponse<LogradouroDTO>>{
        let quark = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'grl/logradouros',
                    environment: environmentv3,
                    filter: filtros
                }),
            }),
            new HttpResponse(
                new LogradouroDTO()
            )
        );
        return quark.call();
    }

    async get(cdLogradouro: number): Promise<Logradouro>{
        let quark = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'grl/logradouros/:cdLogradouro',
                    environment: environmentv3,
                    pathParams: new JSONData({ cdLogradouro: cdLogradouro})
                }),
            }),
            new HttpResponse(
                new Logradouro()
            )
        );

        return await quark.call();
    }

    async update( logradouroDTO: LogradouroDTO):Promise<LogradouroDTO> {
        let quark = new Quark(
            new HttpPut( {
                url: new Url( {
                    id: 'grl/logradouros/:cdLogradouro',
                    environment: environmentv3,
                    pathParams: new JSONData({cdLogradouro: logradouroDTO.cdLogradouro})
                }),
                data: new JSONData(logradouroDTO)
            }),
            new HttpResponse(
                new LogradouroDTO()
            )
        )
        return await quark.call();
    }

    async create( logradouroDTO: LogradouroDTO):Promise<LogradouroDTO> {
        let quark = new Quark(
            new HttpPost( {
                url: new Url( {
                    id: 'grl/logradouros',
                    environment: environmentv3
                }),
                data: new JSONData(logradouroDTO)
            }),
            new HttpResponse(
                new LogradouroDTO()
            )
        )
        return await quark.call();
    }

}